// Idempotent <script> injection. Returns true if the script was newly
// added, false if a tag with the same `src` was already in the DOM.
//
// React 18 StrictMode dev double-invoke fires every useEffect twice on
// mount; raw `document.body.appendChild(scriptEl)` patterns would inject
// duplicate copies of third-party widgets. Several of those widgets
// (donorbox, calendly) declare module-scope identifiers and throw
// "Identifier X has already been declared" on the second load.
//
// Loading once and leaving the tag in place is the safe behavior:
// the widgets mutate window globals that don't unwind via removeChild,
// and re-injection would re-trigger the duplicate-declaration error.

export const loadScriptOnce = (src, attrs = {}) => {
  if (typeof document === 'undefined') return false;
  if (document.querySelector(`script[src="${src}"]`)) return false;
  const script = document.createElement('script');
  script.src = src;
  Object.assign(script, attrs);
  document.body.appendChild(script);
  return true;
};
